exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#edit-header[data-v-9a480ad4]{margin-bottom:0;padding:0}#edit-header .column[data-v-9a480ad4]{margin-bottom:0;padding-bottom:.2rem}.collapse-button[data-v-9a480ad4]{width:-webkit-fill-available}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./node_modules/eslint-loader!./src/components/ChangeEditor.Vue?vue&type=style&index=0&id=9a480ad4&scoped=true&lang=css
// module id = 166
// module chunks = 0